// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"_newPostButton_buttonContainer__7X_Iq","newPostButton":"_newPostButton_newPostButton__sSlJt"};